function formatCurrency(amount) {
  // Handle edge cases
  if (amount === 0) return "₹0";
  if (isNaN(amount)) return "Invalid amount";

  const absAmount = Math.abs(amount);
  const isNegative = amount < 0;

  let result = "";
  let unit = "";
  let value = 0;

  if (absAmount >= 10000000) {
    // 1 Crore and above
    value = absAmount / 10000000;
    unit = "Crore";
  } else if (absAmount >= 100000) {
    // 1 Lakh and above
    value = absAmount / 100000;
    unit = "Lakh";
  } else if (absAmount >= 1000) {
    // 1 Thousand and above
    value = absAmount / 1000;
    unit = "K";
  } else {
    value = absAmount;
    unit = "";
  }

  // Always format to 1 decimal place, no rounding
  let formattedValue;
  if (value % 1 === 0) {
    // For whole numbers, add .0
    formattedValue = value.toFixed(1);
  } else {
    // Truncate to 1 decimal place without rounding
    formattedValue = (Math.floor(value * 10) / 10).toFixed(1);
  }

  result = `₹${formattedValue}${unit ? " " + unit : ""}`;

  return isNegative ? "-" + result : result;
}
export default formatCurrency;
